import React, { useRef } from "react";
import { Canvas, useFrame, useThree } from "react-three-fiber";

// https://www.digitalocean.com/community/tutorials/react-react-with-threejs
// https://spectrum.chat/react-three-fiber/general/camera-change-position~b277d029-8712-496a-affb-6542b1a7567f

function Icosahedron(props) {
    // This reference will give us direct access to the mesh
    const mesh = useRef();

    // Bounds of the view (which stretches 100% and auto-adjusts)
    const { size } = useThree();
    const scale = 1200 / Math.min(size.width, size.height);

    // Rotate mesh every frame, this is outside of React without overhead
    useFrame(() => {
        mesh.current.rotation.x += 0.003;
        mesh.current.rotation.y += 0.002;
    });

    return (
        <mesh {...props} ref={mesh} scale={[scale, scale, scale]}>
            <icosahedronGeometry args={[1.5, 1]} />
            <meshBasicMaterial color={0x525252} wireframe={true} wireframeLinewidth={1} />
        </mesh>
    );
}

export default function Background() {
    return (
        <Canvas>
            <Icosahedron position={[0, 0, 0]} />
        </Canvas>
    );
}
